<form [formGroup]="form" *transloco="let fieldTranslation; read: 'field-types'">
  <div class="flex flex-col space-y-4 w-full">
    <mat-form-field class="fuse-mat-no-subscript w-full">
      <mat-label>{{ fieldTranslation("Placeholder") }}</mat-label>
      <input
        [placeholder]="fieldTranslation('Placeholder')"
        formControlName="placeholder"
        autocomplete="off"
        matInput
      />
    </mat-form-field>
    <mat-form-field class="fuse-mat-no-subscript w-full">
      <mat-label>{{ fieldTranslation("maxNumberOfFiles") }}</mat-label>
      <input
        type="number"
        [placeholder]="fieldTranslation('maxNumberOfFiles')"
        formControlName="maxNumberOfFiles"
        autocomplete="off"
        matInput
        min="1"
        max="10"
        required
      />
    </mat-form-field>
    <mat-form-field>
      <mat-label>{{ fieldTranslation("fileTypes") }}</mat-label>
      <mat-select formControlName="fileTypes" multiple required>
        <mat-option *ngFor="let type of allowedTypes" [value]="type">{{ type }}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</form>
